(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function setup(nav) {
      if (instances.has(nav) || nav.hasAttribute('data-apercu')) return;
      const wrapper = nav.closest('.anchor-nav-section');
      const first = document.querySelector('.main-product-section');
      if (!wrapper || !first) return;
      const controller = new AbortController();
      const {signal} = controller;
      let pairs = [], frame = 0, observer;
      const header = document.querySelector('[data-header]');
      const sentinel = document.createElement('span');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'display:block;height:0;pointer-events:none';
      first.after(sentinel);
      const headerBottom = () => Math.max(0, header?.getBoundingClientRect().bottom || 0);
      function restorePairs() {
        pairs.forEach(pair => {
          pair.target.style.scrollMarginTop = pair.originalScrollMarginTop;
          if (pair.generatedId) pair.target.removeAttribute('id');
        });
      }
      function resolve() {
        restorePairs();
        pairs = [];
        nav.querySelectorAll('[data-anchor-link]').forEach((link, i) => {
          let target;
          try { target = document.querySelector(link.dataset.anchorSelector); } catch (_) {}
          const li = link.closest('li');
          if (!link.dataset.anchorLabel) link.dataset.anchorLabel = link.textContent;
          const missingInEditor = !target && window.Shopify?.designMode;
          if (li) li.hidden = !target && !window.Shopify?.designMode;
          link.textContent = link.dataset.anchorLabel + (missingInEditor ? ' (section absente)' : '');
          if (!target) {link.setAttribute('aria-disabled','true');link.removeAttribute('href');}
          else link.removeAttribute('aria-disabled');
          link.title = missingInEditor ? 'Choisissez une section présente sur cette page dans les réglages du lien.' : '';
          if (!target) return;
          const generatedId = !target.id;
          if (generatedId) target.id = `anchor-${wrapper.id}-${i}`;
          link.href = `#${target.id}`;
          pairs.push({link,target,generatedId,originalScrollMarginTop:target.style.scrollMarginTop});
        });
      }
      function update() {
        frame = 0;
        const top = headerBottom();
        const visible = Boolean((sentinel.getBoundingClientRect().top <= top + 1 && pairs.length > 0) || (window.Shopify?.designMode && nav.dataset.editorSelected === 'true'));
        const height = visible ? nav.getBoundingClientRect().height : 0;
        let active = pairs[0];
        pairs.forEach(pair => {
          pair.top = pair.target.getBoundingClientRect().top;
          if (pair.top <= top + height + 48) active = pair;
        });
        const margin = `${top + height + 8}px`;
        wrapper.classList.toggle('anchor-nav-section--visible', visible);
        if (wrapper.style.top !== `${top}px`) wrapper.style.top = `${top}px`;
        if (nav.inert !== !visible) nav.inert = !visible;
        if (nav.getAttribute('aria-hidden') !== String(!visible)) nav.setAttribute('aria-hidden', String(!visible));
        pairs.forEach(pair => {
          if (pair.target.style.scrollMarginTop !== margin) pair.target.style.scrollMarginTop = margin;
        });
        pairs.forEach(pair => pair.link.toggleAttribute('aria-current', false));
        if (active) active.link.setAttribute('aria-current', 'true');
      }
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      resolve();
      observer = new IntersectionObserver(schedule);
      observer.observe(sentinel);
      const resize = new ResizeObserver(schedule);
      resize.observe(first); resize.observe(nav); if (header) resize.observe(header);
      window.addEventListener('scroll', schedule, {passive:true,signal});
      window.addEventListener('resize', schedule, {passive:true,signal});

      document.addEventListener('shopify:section:select', e => {if(e.target===wrapper){nav.dataset.editorSelected='true';schedule();}}, {signal});
      document.addEventListener('shopify:section:deselect', e => {if(e.target===wrapper){delete nav.dataset.editorSelected;schedule();}}, {signal});
      nav.addEventListener('click', e => {
        const pair = pairs.find(p => p.link === e.target.closest('[data-anchor-link]'));
        if (!pair) return;
        e.preventDefault();
        const hadTabindex = pair.target.hasAttribute('tabindex');
        if (!hadTabindex) pair.target.tabIndex = -1;
        pair.target.focus({preventScroll:true});
        if (!hadTabindex) pair.target.addEventListener('blur', () => pair.target.removeAttribute('tabindex'), {once:true});
        const top = Math.max(0, pair.target.getBoundingClientRect().top + scrollY - headerBottom() - (pair.target===first ? 0 : nav.getBoundingClientRect().height) - 8);
        window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        history.replaceState(null,'',`#${pair.target.id}`);
      }, {signal});
      instances.set(nav, () => {controller.abort();observer.disconnect();resize.disconnect();cancelAnimationFrame(frame);restorePairs();sentinel.remove();wrapper.classList.remove('anchor-nav-section--visible');});
      update();
      let interacted = false;
      const markInteraction = () => {interacted = true;};
      window.addEventListener('pointerdown', markInteraction, {once:true,passive:true,signal});
      window.addEventListener('wheel', markInteraction, {once:true,passive:true,signal});
      function alignHash() {
        let id;
        try {id = decodeURIComponent(location.hash.slice(1));} catch (_) {return;}
        const pair = pairs.find(p => p.target.id === id);
        if (!pair || !nav.isConnected) return;
        update();
        const offset = headerBottom() + (pair.target === first ? 0 : nav.getBoundingClientRect().height) + 8;
        window.scrollTo({top:Math.max(0,pair.target.getBoundingClientRect().top + scrollY - offset),behavior:'instant'});
      }
      if (location.hash && !window.Shopify?.designMode) {
        Promise.resolve(document.fonts?.ready).then(() => requestAnimationFrame(() => {if(!interacted)alignHash();}));
      }
      window.addEventListener('hashchange', alignHash, {signal});
    }
    const init = () => document.querySelectorAll('[data-anchor-nav]').forEach(setup);
    const reset = () => {instances.forEach(dispose => dispose());instances.clear();init();};
    init();
    document.addEventListener('shopify:section:load', reset);
    document.addEventListener('shopify:section:reorder', reset);
    document.addEventListener('shopify:section:unload', event => {
      instances.forEach((dispose,nav) => {dispose();instances.delete(nav);});
      requestAnimationFrame(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catlang-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var controllers = window.CatharsisExplorerControllers || new Map();
    window.CatharsisExplorerControllers = controllers;
    function initialise(root) {
      if (!root || controllers.has(root)) return;
      var views = Array.prototype.slice.call(root.querySelectorAll('[data-explorer-view]'));
      var controls = root.querySelector('[data-explorer-controls]'); var info = root.querySelector('[data-explorer-info]');
      if (!views.length || !controls) return;
      var controller = new AbortController(); var signal = controller.signal;
      function closeSpots() { root.querySelectorAll('[data-explorer-point][aria-expanded="true"]').forEach(function (spot) { spot.setAttribute('aria-expanded', 'false'); }); if (info) info.hidden = true; }
      var visibleViews = views.filter(function (view) { return window.getComputedStyle(view).display !== 'none'; });
      if (!visibleViews.length) visibleViews = views;
      function selectView(id) {
        var view = views.filter(function (item) { return item.getAttribute('data-explorer-view') === id; })[0]; if (!view) return; closeSpots();
        views.forEach(function (item) { var selected = item === view; item.classList.toggle('is-active', selected); item.setAttribute('aria-hidden', String(!selected)); });
        Array.prototype.slice.call(controls.querySelectorAll('[data-explorer-angle]')).forEach(function (button) { var selected = button.getAttribute('data-explorer-angle') === id; button.classList.toggle('is-active', selected); button.setAttribute('aria-pressed', String(selected)); });
      }
      visibleViews.forEach(function (view) {
        var id = view.getAttribute('data-explorer-view'); var label = view.getAttribute('data-explorer-label') || 'Vue du produit'; var button = document.createElement('button');
        button.type = 'button'; button.className = 'explorer__angle-btn'; button.setAttribute('data-explorer-angle', id); button.setAttribute('aria-pressed', 'false'); button.textContent = label;
        button.addEventListener('click', function () { selectView(id); }, { signal: signal }); controls.appendChild(button);
      });
      root.classList.add('is-initialised');
      var initial = visibleViews.filter(function (item) { return item.getAttribute('data-explorer-initial') === 'true'; })[0] || visibleViews[0]; selectView(initial.getAttribute('data-explorer-view'));
      root.addEventListener('click', function (event) { var spot = event.target.closest('[data-explorer-point]'); if (!spot || !root.contains(spot)) return; var open = spot.getAttribute('aria-expanded') === 'true'; closeSpots(); if (open || !info) return; spot.setAttribute('aria-expanded', 'true'); info.textContent = spot.getAttribute('data-explorer-point-text') || ''; info.hidden = false; }, { signal: signal });
      root.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeSpots(); }, { signal: signal });
      var resizeTimer;
      window.addEventListener('resize', function () { window.clearTimeout(resizeTimer); resizeTimer = window.setTimeout(function () { var item = controllers.get(root); if (item) item.destroy(); initialise(root); }, 120); }, { signal: signal });
      controllers.set(root, { close: closeSpots, destroy: function () { controller.abort(); window.clearTimeout(resizeTimer); controls.replaceChildren(); root.classList.remove('is-initialised'); controllers.delete(root); } });
    }
    function rootsWithin(node) { var roots = []; if (node && node.matches && node.matches('[data-explorer]')) roots.push(node); if (node && node.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(node.querySelectorAll('[data-explorer]'))); return roots; }
    function initWithin(node) { rootsWithin(node).forEach(initialise); }
    function destroyWithin(node) { rootsWithin(node).forEach(function (root) { var item = controllers.get(root); if (item) item.destroy(); }); }
    if (!window.CatharsisExplorerEventsBound) {
      window.CatharsisExplorerEventsBound = true;
      document.addEventListener('click', function (event) { controllers.forEach(function (item, root) { if (!root.contains(event.target)) item.close(); }); });
      document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); }); document.addEventListener('shopify:section:unload', function (event) { destroyWithin(event.target); });
      document.addEventListener('shopify:block:select', function (event) { var id = event.detail && event.detail.blockId; if (!id) return; controllers.forEach(function (item, root) { var selected = Array.prototype.slice.call(root.querySelectorAll('[data-explorer-block-id]')).filter(function (element) { return element.getAttribute('data-explorer-block-id') === id; })[0]; if (!selected) return; var view = selected.matches('[data-explorer-view]') ? selected : selected.closest('[data-explorer-view]'); if (view) root.querySelector('[data-explorer-angle="' + view.getAttribute('data-explorer-view') + '"]').click(); }); });
    }
    initWithin(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-kit"] && !Shopify.designMode) return;
  try {
    
  // Sélecteur de variante en ligne : change le prix affiché et la cible du bouton d'ajout.
  (function () {
    document.querySelectorAll('[data-kit]').forEach(function (root) {
      root.addEventListener('change', function (e) {
        var select = e.target.closest('[data-kit-select]');
        if (!select) return;
        var card = select.closest('[data-kit-item]');
        if (!card) return;
        var opt = select.options[select.selectedIndex];
        var price = card.querySelector('[data-kit-price]');
        if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
        var add = card.querySelector('[data-kit-add]');
        if (add) add.setAttribute('data-xsell-add', opt.value);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  // Filtres d'avis : une puce active à la fois. « Tous » réaffiche tout.
  (function () {
    document.querySelectorAll('[data-reviews]').forEach(function (root) {
      var filters = root.querySelector('[data-rev-filters]');
      if (!filters) return;
      filters.hidden = false;
      var chips = filters.querySelectorAll('[data-rev-filter]');
      var cards = root.querySelectorAll('[data-rev-card]');
      var none = root.querySelector('[data-rev-none]');

      filters.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-rev-filter]');
        if (!chip) return;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        var kind = chip.getAttribute('data-kind');
        var value = chip.getAttribute('data-value');
        var visible = 0;
        cards.forEach(function (card) {
          var show = kind === 'all' || card.getAttribute('data-' + kind) === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (none) none.hidden = visible > 0;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    // Pre-select the saved country in each address form
    document.querySelectorAll('select[data-default]').forEach(function (sel) {
      var def = sel.getAttribute('data-default');
      if (def) sel.value = def;
    });
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-address-toggle]');
      if (toggle) {
        var el = document.getElementById(toggle.getAttribute('data-address-toggle'));
        if (el) {
          var open = el.hidden;
          el.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }
      var del = e.target.closest('[data-address-delete]');
      if (del) {
        if (window.confirm(del.getAttribute('data-confirm'))) {
          var url = del.getAttribute('data-address-delete');
          var form = document.createElement('form');
          form.method = 'post';
          form.action = url;
          var method = document.createElement('input');
          method.type = 'hidden'; method.name = '_method'; method.value = 'delete';
          form.appendChild(method);
          document.body.appendChild(form);
          form.submit();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // Sur ordinateur la colonne des filtres est à côté de la grille : on les déplie tous.
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      document.querySelectorAll('[data-facet]').forEach(function (d) { d.open = true; });
    }
    var form = document.querySelector('[data-facets-form]');
    var sort = document.querySelector('[data-sort-select]');

    function applyFilters() {
      if (!form) return;
      var params = new URLSearchParams(new FormData(form));
      // strip empty price fields so URL stays clean
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var base = window.location.pathname;
      window.location.href = base + (clean.toString() ? '?' + clean.toString() : '');
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"]')) applyFilters();
      });
      // debounce price inputs
      var t;
      form.addEventListener('input', function (e) {
        if (e.target.matches('input[type="number"]')) {
          clearTimeout(t);
          t = setTimeout(applyFilters, 700);
        }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(); });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var recover = document.getElementById('RecoverPassword');
    var login = document.getElementById('LoginForm');
    if (!recover || !login) return;
    function show(which) {
      recover.hidden = which !== 'recover';
      login.hidden = which !== 'login';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show('recover'); }
      else if (e.target.closest('[data-show-login]')) { e.preventDefault(); show('login'); }
    });
    if (window.location.hash === '#recover') show('recover');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-drawer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mobile-menu]');
    if (!root) return;
    var panel = root.querySelector('[data-nav-panel]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastFocus = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    }
    function onTrap(e) {
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      /* hidden -> visible en deux temps, sinon la transition ne part jamais. */
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      document.body.style.overflow = 'hidden';
      var c = root.querySelector('[data-menu-close]'); if (c) c.focus();
      document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      panel.addEventListener('keydown', onTrap);
    }

    function close() {
      root.classList.remove('is-open');
      var done = function () {
        root.hidden = true;
        closeSub(true);
      };
      if (reduceMotion) { done(); }
      else {
        var p = root.querySelector('.nav-drawer__panel');
        var fired = false;
        var onEnd = function () { if (!fired) { fired = true; p.removeEventListener('transitionend', onEnd); done(); } };
        p.addEventListener('transitionend', onEnd);
        setTimeout(onEnd, 450); /* filet : si transitionend ne vient pas, on ferme quand même */
      }
      document.body.style.overflow = '';
      document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      panel.removeEventListener('keydown', onTrap);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    /* ── Descente (drill-down) ── */
    var activeSub = null;
    var drillTrigger = null;

    function openSub(id, trigger) {
      var sub = root.querySelector('[data-nav-sub="' + id + '"]');
      if (!sub) return;
      activeSub = sub;
      drillTrigger = trigger || null;
      sub.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { sub.classList.add('is-active'); }); });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var back = sub.querySelector('[data-nav-back]'); if (back) back.focus();
    }

    function closeSub(instant) {
      if (!activeSub) return;
      var sub = activeSub;
      activeSub = null;
      sub.classList.remove('is-active');
      var done = function () { sub.hidden = true; };
      if (instant || reduceMotion) { done(); }
      else {
        var fired = false;
        var onEnd = function () { if (!fired) { fired = true; sub.removeEventListener('transitionend', onEnd); done(); } };
        sub.addEventListener('transitionend', onEnd);
        setTimeout(onEnd, 450);
      }
      if (drillTrigger) {
        drillTrigger.setAttribute('aria-expanded', 'false');
        if (!instant) drillTrigger.focus();
        drillTrigger = null;
      }
    }

    document.addEventListener('click', function (e) {
      var drill = e.target.closest('[data-nav-drill]');
      if (drill && root.contains(drill)) { openSub(drill.getAttribute('data-nav-drill'), drill); return; }
      if (e.target.closest('[data-nav-back]')) { closeSub(false); return; }
      if (e.target.closest('[data-menu-open]')) open();
      else if (e.target.closest('[data-menu-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || root.hidden) return;
      if (activeSub) closeSub(false);
      else close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-panels"] && !Shopify.designMode) return;
  try {
    
  /* Panneaux épinglés : fondu du média au passage des panneaux, et mode « défilement » où le
     film suit la position de lecture voulue par interpolation (jamais d'à-coup sec). */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      var media = Array.prototype.slice.call(root.querySelectorAll('[data-pinned-media]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pinned-panel]'));
      var base = root.querySelector('.pinned__img.is-active');

      if (media.length && panels.length && !reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var want = en.target.getAttribute('data-media-for');
            var found = false;
            media.forEach(function (m) {
              var hit = m.getAttribute('data-media-id') === want;
              m.classList.toggle('is-active', hit);
              if (hit) found = true;
            });
            if (base) base.classList.toggle('is-active', !found || want === 'base');
          });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        panels.forEach(function (p) { io.observe(p); });
      }

      var mode = root.getAttribute('data-media-mode');
      var vid = mode === 'scrub' ? root.querySelector('.pinned__media video') : null;
      if (vid && !reduce) {
        var target = 0;
        var current = 0;
        var raf = null;
        function progress() {
          var r = root.getBoundingClientRect();
          var total = r.height - window.innerHeight;
          if (total <= 0) return 0;
          return Math.min(1, Math.max(0, -r.top / total));
        }
        function tick() {
          current += (target - current) * 0.12;
          if (vid.duration) {
            try { vid.currentTime = vid.duration * current; } catch (e) { /* métadonnées pas prêtes */ }
          }
          if (Math.abs(target - current) > 0.001) {
            raf = requestAnimationFrame(tick);
          } else {
            raf = null;
          }
        }
        function onScroll() {
          target = progress();
          if (!raf) raf = requestAnimationFrame(tick);
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        vid.addEventListener('loadedmetadata', onScroll);
        onScroll();
      }

      var loopVid = mode === 'loop' ? root.querySelector('.pinned__media video') : null;
      if (loopVid && reduce) {
        loopVid.pause();
        loopVid.removeAttribute('autoplay');
      }
    }

    document.querySelectorAll('[data-pinned]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  /* Pastilles « i » de la grille : une seule ligne d'information partagée par rangée.
     Toucher une pastille écrit sa précision dans la ligne [data-info-out] du panneau ;
     retoucher la même pastille, toucher ailleurs ou Échap la referme. */
  (function () {
    function closeInfos(scope) {
      (scope || document).querySelectorAll('[data-info-btn][aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      (scope || document).querySelectorAll('[data-info-out]:not([hidden])').forEach(function (out) {
        out.hidden = true;
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-info-btn]');
      if (!btn) {
        closeInfos(document);
        return;
      }
      var panel = btn.closest('[data-accordion-panel]');
      var out = panel ? panel.querySelector('[data-info-out]') : null;
      if (!out) return;
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      closeInfos(document);
      if (wasOpen) return;
      btn.setAttribute('aria-expanded', 'true');
      out.textContent = btn.getAttribute('data-info-text') || '';
      out.hidden = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeInfos(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-product-recs]');
    if (!el) return;
    var grid = el.querySelector('.product-recs__grid');
    if (!grid || !grid.hasAttribute('aria-busy')) return;
    fetch(el.getAttribute('data-url'), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recs]');
        // `fresh` existe TOUJOURS : Shopify rend l'élément de section même lorsqu'il n'a aucune
        // recommandation à proposer. Tester sa seule présence remplaçait donc le contenu par du
        // vide et laissait la section occuper ses 128px de marges — un trou mesuré sur la fiche
        // produit. Ce qui compte est la présence d'au moins une carte.
        if (fresh && fresh.querySelector('.product-card')) el.innerHTML = fresh.innerHTML;
        else el.remove();
      })
      .catch(function () { el.remove(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
